/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { connect } from 'react-redux';
import { Link, Navigate } from 'react-router-dom';
import { history } from 'CustomHistory';
import { submitDeviceSelectionTab } from 'store/modules/device-selection/actions';
import { logout } from 'store/modules/login/actions';
import { withRouter } from 'modules/withRouter';
import { Events } from 'util/constants';
import { ClearIcon, LeftArrow } from 'assets/images';
import {
  getUserSelectedCameraDeviceId,
  getUserSelectedMicDeviceId,
  getUserSelectedOutputDeviceId
} from 'store/modules/base/settings/functions';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Button from './components/Button';
import utils from 'util/utils';
import JitsiMeetJS from 'store/modules/base/lib-jitsi-meet';
import AlertDialog from './components/AlertDialog';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { setCameraFacingMode } from 'store/modules/base/media';

const Settings = (props) => {
  const { _user, updateDevices, availableDevices, signout } = props;
  const [error, setError] = React.useState(null);
  const [joinAlert, setJoinAlert] = React.useState(false);
  const [timer, setTimer] = useState(60);
  const [timerStart, setTimerStart] = useState(false);
  const [rememberLogin, setRememberLogin] = useState(true);
  const [autoLogin, setAutoLogin] = useState(false);
  const [quickLogin, setQuickLogin] = useState(false);
  const [defaultCamera, setDefaultCamera] = useState('');
  const [defaultMicrophone, setDefaultMicrophone] = useState('');
  const [defaultSpeaker, setDefaultSpeaker] = useState('');
  const [open, setOpen] = React.useState(0);
  const [rotate, setRotate] = useState('');
  const [zoom, setZoom] = useState(1);
  const intervalRef = useRef(null);
  const quickTimerRunning = useRef(false);
  useEffect(() => {
    APP.conference._initDeviceList(true);
    joinRoom();
    start();
    return () => {
      stop();
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
  useEffect(() => {
    if (defaultCamera && defaultCamera !== '') {
      start();
    }
  }, [defaultCamera]);
  useEffect(() => {
    getMediaDevices();
  }, [availableDevices]);
  useEffect(() => {
    if (autoLogin && timer < 1) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = null;
      setTimerStart(false);
      quickTimerRunning.current = false;
      checkRemoteLogins();
    }
  }, [timer]);

  function startTimer(t = 60) {
    setTimer(t);
    setTimerStart(true);
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
  }

  async function joinRoom() {
    const storedAutoLogin = await utils.getAutoLogin();
    const storedQuickLogin = await utils.getQuickLogin();
    setAutoLogin(storedAutoLogin !== 'false');
    setQuickLogin(storedQuickLogin !== 'false');

    if (window.joinNewRoom) {
      history.push('/groups', { state: { room: window.joinNewRoom } });
      window.joinNewRoom = null;
    } else if (storedAutoLogin !== 'false') {
      if (storedQuickLogin == 'true') {
        startTimer(10);
        quickTimerRunning.current = true;
      } else {
        startTimer(60);
      }
    }
  }

  // const videoLeftControl = () => {
  //   if (rotate !== -90) {
  //     setRotate(0);
  //     setRotate(-90);
  //   } else {
  //     setRotate(-90);
  //   }
  // };

  // const videoRightControl = () => {
  //   if (rotate !== 90) {
  //     setRotate(0);
  //     setRotate(90);
  //   } else {
  //     setRotate(90);
  //   }
  // };

  // const videoDownControl = () => {
  //   if (rotate !== 0) {
  //     setRotate(0);
  //     setRotate(180);
  //   } else {
  //     setRotate(180);
  //   }
  // };

  // const videoUpControl = () => {
  //   setRotate(0);
  // };

  // const zoomInControl = () => {
  //   const value = parseFloat(zoom);

  //   if (zoom !== 1.2) {
  //     setZoom(parseFloat(value + 0.1).toFixed(1));
  //   }
  // };

  // const zoomOutControl = () => {
  //   const value = parseFloat(zoom);

  //   if (zoom !== 0.8) {
  //     setZoom(parseFloat(value - 0.1).toFixed(1));
  //   }
  // };

  function stop() {
    const videoElement = document.getElementById('videoElement');
    const stream = videoElement?.srcObject;
    if (stream && videoElement) {
      const tracks = stream.getTracks();

      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i];

        track.stop();
      }
      videoElement.srcObject = null;
    }
    if (window.stream) {
      window.stream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  }
  async function start() {
    stop();
    utils.clearUserEmail();
    const videoSource = defaultCamera;
    const audioSource = defaultMicrophone;
    const constraints = {
      audio: {
        deviceId: audioSource ? { exact: audioSource } : undefined,
        echoCancellation: true
      },
      video: {
        advanced: [
          { width: { exact: 2560 } },
          { width: { exact: 1920 } },
          { width: { exact: 1280 } },
          { width: { exact: 1024 } },
          { width: { exact: 900 } },
          { width: { exact: 800 } },
          { width: { exact: 640 } },
          { width: { exact: 320 } }
        ],
        deviceId: videoSource ? { exact: videoSource } : undefined
      }
    };

    const ChromeSamples = {
      log() {
        // eslint-disable-next-line prefer-rest-params
        const line = Array.prototype.slice
          .call(arguments)
          // eslint-disable-next-line no-confusing-arrow
          .map((argument) =>
            typeof argument === 'string' ? argument : JSON.stringify(argument)
          )
          .join(' ');

        if (line !== null) {
          console.log(line);

          // document.querySelector('#log').textContent = line + '\n';
        }
      },

      clearLog() {
        // document.querySelector('#log').textContent = '';
      },

      setStatus() {
        // document.querySelector('#status').textContent = status;
      },

      setContent(newContent) {
        const content = document.querySelector('#content');

        while (content.hasChildNodes()) {
          content.removeChild(content.lastChild);
        }
        content.appendChild(newContent);
      }
    };

    window.addEventListener('error', (error) => {
      if (ChromeSamples && ChromeSamples.setStatus) {
        // console.log(error);
        ChromeSamples.setStatus(
          `${error.message} (Your browser may not support this feature.)`
        );
        error.preventDefault();
      }
    });

    if (/Chrome\/(\d+\.\d+.\d+.\d+)/.test(navigator.userAgent)) {
      // Let's log a warning if the sample is not supposed to execute on this
      // version of Chrome.
      if (parseInt(RegExp.$1, 10) < 59) {
        ChromeSamples.setStatus(
          `Warning! Keep in mind this sample has been tested with Chrome ${59}.`
        );
      }
    }
    try {
      Promise.all([
        JitsiMeetJS.mediaDevices.isDevicePermissionGranted('audio'),
        JitsiMeetJS.mediaDevices.isDevicePermissionGranted('video')
      ])
        .then((results) => {
          getUserMedia(constraints);
        })
        .catch(() => {
          getUserMedia(constraints);
        });
    } catch (e) {
      console.log(e);
      getUserMedia(constraints);
    }
  }

  function getUserMedia(constraints) {
    function sleep(ms = 0) {
      return new Promise((r) => setTimeout(r, ms));
    }
    try {
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(async (mediaStream) => {
          mediaStream.volume = 0;
          document.querySelector('video').srcObject = mediaStream;
          const audioTrack = mediaStream.getAudioTracks()[0];

          audioTrack.stop();

          // Once crbug.com/711524 is fixed, we won't need to wait anymore. This is
          // currently needed because capabilities can only be retrieved after the
          // device starts streaming. This happens after and asynchronously w.r.t.
          // getUserMedia() returns.
          await sleep(1000);
          const track = mediaStream.getVideoTracks()[0];
          const capabilities = track.getCapabilities();
          const settings = track.getSettings();

          const input = document.querySelector('input[type="range"]');

          // Check whether zoom is supported or not.
          if (!('zoom' in capabilities)) {
            return Promise.reject(`Zoom is not supported by ${track.label}`);
          }

          // Map zoom to a slider element.
          input.min = capabilities.zoom.min;
          input.max = capabilities.zoom.max;
          input.step = capabilities.zoom.step;
          input.value = settings.zoom;
          input.oninput = function (event) {
            track.applyConstraints({
              advanced: [{ zoom: event.target.value }]
            });
          };
          input.hidden = false;
          props.dispatch(setCameraFacingMode(settings.facingMode));
        })
        .catch((error) => console.log('Argh!', error));
    } catch (e) {
      console.log(e);
    }
  }
  async function getMediaDevices() {
    try {
      // const videoSource = await utils.getItem('cameraid');
      // const audioSource = await utils.getItem('microphoneid');
      // const speakerSource = await utils.getItem('speakerid');
      let available = availableDevices?.videoInput?.some(
        (item) => item.deviceId === props.selectedVideoInputId
      );
      setDefaultCamera(
        available
          ? props.selectedVideoInputId
          : availableDevices?.videoInput[0]?.deviceId
      );
      available = availableDevices?.audioInput?.some(
        (item) => item.deviceId === props.selectedAudioInputId
      );
      setDefaultMicrophone(
        available
          ? props.selectedAudioInputId
          : availableDevices?.audioInput[0]?.deviceId
      );
      available = availableDevices?.audioOutput?.some(
        (item) => item.deviceId === props.selectedAudioOutputId
      );
      setDefaultSpeaker(
        available
          ? props.selectedAudioOutputId
          : availableDevices?.audioOutput[0]?.deviceId
      );
    } catch (e) {
      console.log(e);
    }
  }

  const cancelAutoLogin = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = null;
    setTimer(60);
    setAutoLogin(false);
    setQuickLogin(false);
    setTimerStart(false);
    quickTimerRunning.current = false;
  };

  /**
   * Checks if this is an Office device and if another device is live with this login, if so shows logout warning
   */
  const checkRemoteLogins = async () => {
    if (_user && _user.device) {
      setError(null);
      if (
        utils.isRemoteLogin(_user) !== true &&
        utils.isConferenceLive(_user.device.status)
      ) {
        setJoinAlert(true);
        return;
      }
      await signIn();
    } else {
      setError(
        'Device not configured for logged in user, please contact your distributor.'
      );
    }
  };

  const signIn = async () => {
    if (_user && _user?.device) {
      setError(null);
      stop();
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = null;
      setTimerStart(false);
      quickTimerRunning.current = false;
      updateDevices({
        selectedVideoInputId: defaultCamera,
        selectedAudioInputId: defaultMicrophone,
        selectedAudioOutputId: defaultSpeaker
      });
      utils.setItem('cameraid', defaultCamera);
      utils.setItem('microphoneid', defaultMicrophone);
      utils.setItem('speakerid', defaultSpeaker);
      if (rememberLogin) {
        utils.saveRememberLogin(_user);
        utils.saveAutoLogin(autoLogin);
        utils.saveQuickLogin(quickLogin);
      } else {
        utils.clearRememberLogin();
      }
      if (window.ReactNativeWebView) {
        console.log('RN environment AutoLogin:', autoLogin);
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ autoLaunch: autoLogin })
        );
      }
      if (window.isDesktop) {
        console.log('Electron environment AutoLogin:', autoLogin);
        try {
          window.COM.send(Events.CONFIGURE, { autoLaunch: autoLogin });
        } catch (e) {
          console.log(
            `COM:: context isolation could not send message ${e.message}`
          );
        }
      }
      if (utils.isRemoteLogin(_user)) {
        history.push('/groups');
      } else {
        let groups = _user.device?.groups;
        if (groups) {
          let group = groups[0];
          const homegroup = groups.filter((item) => item.home);
          if (homegroup?.length > 0) group = homegroup[0];
          history.push('/groups', {
            room: typeof group._id === 'string' ? group._id : group._id._id
          });
        } else {
          setError('Logged in device not joined any group for now');
        }
      }
    } else {
      setError(
        'Device not configured for logged in user, please contact your distributor'
      );
    }
  };
  const handleClose = () => {
    setOpen(0);
  };
  const handleOpen = (id) => {
    setOpen(id);
  };
  function _renderSelector(_deviceSelectorProps) {
    const _onSelect = (e) => {
      const deviceId = e.target.value;
      // if (_deviceSelectorProps.selectedDeviceId !== deviceId) {
      _deviceSelectorProps.onSelect(deviceId);
      // }
    };
    return (
      <FormControl
        variant="standard"
        sx={{ display: 'block', width: '100%', margin: '16px 0 16px 0' }}
        key={_deviceSelectorProps.id}>
        <InputLabel id="demo-simple-select-standard-label">
          <Typography variant="labelTiny" className={classes.footer}>
            {_deviceSelectorProps.label}
          </Typography>
        </InputLabel>
        <Select
          className="fullSelect"
          id="demo-controlled-open-select"
          labelId="demo-controlled-open-select-label"
          onChange={_onSelect}
          onClose={handleClose}
          onOpen={() => handleOpen(_deviceSelectorProps.id)}
          open={open === _deviceSelectorProps.id}
          value={
            _deviceSelectorProps.id === 'audioInput'
              ? defaultMicrophone
              : _deviceSelectorProps.id === 'videoInput'
              ? defaultCamera
              : defaultSpeaker
          }>
          {_deviceSelectorProps.devices.map((device) => (
            <MenuItem key={device.deviceId} value={device.deviceId}>
              {device.label || device.deviceId}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  function _renderSelectors() {
    const { availableDevices, hasAudioPermission, hasVideoPermission } = props;

    const configurations = [
      {
        devices: availableDevices.audioInput,
        hasPermission: hasAudioPermission,
        icon: 'icon-microphone',
        isDisabled: false,
        key: 'audioInput',
        id: 'audioInput',
        label: 'Select Microphone',
        onSelect: (selectedAudioInputId) =>
          setDefaultMicrophone(selectedAudioInputId),
        selectedDeviceId: props.selectedAudioInputId
      },
      {
        devices: availableDevices.videoInput,
        hasPermission: hasVideoPermission,
        icon: 'icon-camera',
        isDisabled: false,
        key: 'videoInput',
        id: 'videoInput',
        label: 'Select Webcam',
        onSelect: (selectedVideoInputId) => {
          setDefaultCamera(selectedVideoInputId);
        },
        selectedDeviceId: props.selectedVideoInputId
      },
      {
        devices: availableDevices.audioOutput,
        hasPermission: hasAudioPermission || hasVideoPermission,
        icon: 'icon-speaker',
        isDisabled: false,
        key: 'audioOutput',
        id: 'audioOutput',
        label: 'Select Speaker',
        onSelect: (selectedAudioOutputId) =>
          setDefaultSpeaker(selectedAudioOutputId),
        selectedDeviceId: props.selectedAudioOutputId
      }
    ];

    return configurations.map((config) => _renderSelector(config));
  }

  const classes = useStyles();
  return (
    <Box className="outerContainer">
      {!_user && <Navigate replace={true} to="/login" />}
      <Box sx={{ padding: '24px 16px', overflow: 'scroll' }}>
        <Link onClick={() => stop()} className={classes.link} to="/login">
          <LeftArrow height={20} style={{ marginRight: '9px' }} width={20} />
          <Typography variant="labelSmall" className={classes.hint}>
            back
          </Typography>
        </Link>
        <Box className="center">
          <Box className="left">
            <Typography variant="labelTiny" className={classes.hint}>
              1. Accept camera / mic request if requested
            </Typography>
            <Typography
              variant="labelTiny"
              className={classes.hint}
              style={{ padding: '6px 0px' }}>
              2. Check your settings
            </Typography>
            <Typography variant="labelTiny" className={classes.hint}>
              3. Lets go!
            </Typography>
          </Box>
          <Box className={classes.settingsCenter}>
            <Box>
              <Box className="videoBox">
                <video
                  autoPlay
                  playsInline
                  id="videoElement"
                  style={{ transform: `rotate(${rotate}deg) scale(${zoom})` }}
                />
              </Box>
              {/* <Box className="flex">
                <FabButton
                  Icon={LeftArrowIcon}
                  onClick={videoLeftControl}
                  size={20}
                />
                <FabButton
                  Icon={RightArrowIcon}
                  onClick={videoRightControl}
                  size={20}
                />
                <FabButton
                  Icon={DownArrowIcon}
                  onClick={videoDownControl}
                  size={20}
                />
                <FabButton
                  Icon={UpArrowIcon}
                  onClick={videoUpControl}
                  size={20}
                />
                <FabButton
                  Icon={ZoomInIcon}
                  onClick={zoomInControl}
                  size={15}
                />
                <FabButton
                  Icon={ZoomOutIcon}
                  onClick={zoomOutControl}
                  size={15}
                />
              </Box> */}
            </Box>
            <Box className={classes.container}>
              <Box
                sx={{
                  marginX: 'auto',
                  width: '300px'
                }}>
                {_renderSelectors()}
              </Box>
            </Box>
            <Box className={classes.container}>
              <FormGroup sx={{ width: 'fit-content', marginX: 'auto' }}>
                <FormControlLabel
                  className="chkBox"
                  id="remember-login"
                  control={
                    <Checkbox
                      checked={rememberLogin}
                      className="chkBox"
                      classes={{}}
                      onChange={(e) => {
                        setRememberLogin(e.target.checked);
                        if (autoLogin) {
                          setAutoLogin(e.target.checked);
                          if (timerStart) cancelAutoLogin();
                        }
                        if (quickLogin) {
                          setQuickLogin(e.target.checked);
                        }
                      }}
                      size="small"
                    />
                  }
                  label={
                    <Typography variant="labelTiny" className={classes.hint}>
                      Remember Login & Settings
                    </Typography>
                  }
                  sx={{ width: 'max-content !important' }}
                />
                <FormControlLabel
                  className="chkBox"
                  id="auto-login"
                  control={
                    <Checkbox
                      checked={autoLogin}
                      onChange={(e) => {
                        setAutoLogin(e.target.checked);
                        if (e.target.checked)
                          setRememberLogin(e.target.checked);
                        if (timerStart && !e.target.checked) {
                          cancelAutoLogin();
                        } else if (!timerStart && e.target.checked) {
                          startTimer(60);
                        }
                        if (quickLogin) {
                          setQuickLogin(e.target.checked);
                        }
                      }}
                      size="small"
                    />
                  }
                  label={
                    <Typography variant="labelTiny" className={classes.hint}>
                      Auto-Login
                    </Typography>
                  }
                />
                <FormControlLabel
                  className="chkBox"
                  id="skip-login"
                  control={
                    <Checkbox
                      checked={quickLogin}
                      onChange={(e) => {
                        setQuickLogin(e.target.checked);
                        if (e.target.checked) {
                          setAutoLogin(e.target.checked);
                          if (!timerStart) startTimer(60);
                          setRememberLogin(e.target.checked);
                        } else {
                          if (quickTimerRunning.current) {
                            setTimer((previous) => previous + 50);
                            quickTimerRunning.current = false;
                          }
                        }
                      }}
                      size="small"
                    />
                  }
                  label={
                    <Typography variant="labelTiny" className={classes.hint}>
                      Quick Login
                    </Typography>
                  }
                />
              </FormGroup>
              <Box
                onClick={() => signout()}
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                  marginY: '10px'
                }}>
                <ClearIcon color="#000" height={20} width={20} />
                <Typography
                  className={classes.hint}
                  variant="labelTiny"
                  style={{
                    marginLeft: '8px'
                  }}>
                  Clear Cache
                </Typography>
              </Box>
              {autoLogin && timerStart && (
                <Typography
                  variant="labelTiny"
                  className={classes.hint}
                  onClick={cancelAutoLogin}>
                  Auto-Login will be triggered in {timer} seconds, if you would
                  like to connect now then hit connect else
                  <Box
                    onClick={cancelAutoLogin}
                    sx={{
                      textDecorationLine: 'underline',
                      color: 'black',
                      margin: '2px'
                    }}>
                    Click here
                  </Box>
                  to cancel auto-login
                </Typography>
              )}
              <Box>
                <div className="link">
                  <Button blue={true} onClick={checkRemoteLogins}>
                    Sign In
                  </Button>
                </div>
              </Box>
              {error && (
                <Box
                  className={classes.errorText}
                  style={{ marginTop: '16px' }}>
                  {error}
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <AlertDialog
        open={joinAlert}
        handleClose={() => setJoinAlert(false)}
        onYes={() => {
          setJoinAlert(false);
          signIn();
        }}
        title={
          utils.isRemoteLogin(_user)
            ? 'notify.mulipleRemoteLoginTitle'
            : 'notify.mulipleOfficeLoginTitle'
        }
        description={
          utils.isRemoteLogin(_user)
            ? 'notify.mulipleRemoteLoginMessage'
            : 'notify.mulipleOfficeLoginMessage'
        }
      />
    </Box>
  );
};

Settings.propTypes = {
  _user: PropTypes.object,
  videoMuted: PropTypes.any,
  availableDevices: PropTypes.any,
  hasAudioPermission: PropTypes.bool,
  hasVideoPermission: PropTypes.bool,
  selectedAudioInputId: PropTypes.string,
  selectedAudioOutputId: PropTypes.string,
  selectedVideoInputId: PropTypes.string,
  updateDevices: PropTypes.func,
  signout: PropTypes.func,
  dispatch: PropTypes.func
};

/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {Object}
 */
function _mapStateToProps(state) {
  // const settings = state['features/base/settings'];
  const { permissions, availableDevices } = state['features/base/devices'];
  // const selectedAudioInputId = settings.micDeviceId;
  // const selectedAudioOutputId = getAudioOutputDeviceId();
  // const selectedVideoInputId = settings.cameraDeviceId;
  const selectedAudioInputId = getUserSelectedMicDeviceId(state);
  const selectedAudioOutputId = getUserSelectedOutputDeviceId(state);
  const selectedVideoInputId = getUserSelectedCameraDeviceId(state);
  return {
    availableDevices,
    hasAudioPermission: permissions.audio,
    hasVideoPermission: permissions.video,
    selectedAudioInputId,
    selectedAudioOutputId,
    selectedVideoInputId
  };
}

/**
 * Maps dispatching of some actions to React component props.
 *
 * @param {Function} dispatch - Redux action dispatcher.
 * @private
 * @returns {{
 * }}
 */
export function _mapDispatchToProps(dispatch) {
  return {
    dispatch,
    updateDevices: (state) => dispatch(submitDeviceSelectionTab(state, true)),
    signout: () => dispatch(logout())
  };
}
const useStyles = makeStyles((theme) => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    textDecoration: 'none'
  },
  container: {
    width: '100%',
    marginTop: '10px'
  },
  settingsCenter: {
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '@media (min-width: 600px) and (max-height: 500px)': {
      flexDirection: 'row'
    }
  },
  hint: {
    display: 'block',
    marginTop: '5px',
    maxWidth: '350px',
    color: theme.palette.text07Info
  },
  footer: {
    color: theme.palette.dividerColor
  }
}));
export default React.memo(
  withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(withBoundary(Settings))
  )
);
